import React from "react";
import { useNavigate } from "react-router-dom";

interface EstadoRevisionDocumentosProps {
  pendingReviewCount: number;
  reviewedToday: number;
}

const EstadoRevisionDocumentos: React.FC<EstadoRevisionDocumentosProps> = ({
  pendingReviewCount,
  reviewedToday,
}) => {
  const navigate = useNavigate();
  const [isHovered, setIsHovered] = React.useState(false);
  const safeReviewedCount = Math.max(0, reviewedToday || 0);
  const total = pendingReviewCount + safeReviewedCount;

  const reviewedPercentage =
    total > 0 ? Math.round((safeReviewedCount / total) * 100) : 100;
  const pendingPercentage =
    total > 0 ? Math.round((pendingReviewCount / total) * 100) : 0;

  return (
    <div
      style={{
        ...styles.chartCard,
        display: "flex",
        flexDirection: "column",
        width: "100%",
        flex: 1,
        minHeight: 0,
      }}
    >
      <div style={styles.chartHeader}>
        <div style={styles.chartHeaderContent}>
          <h3 style={styles.chartTitle}>
            <i
              className="fa-solid fa-clipboard-check"
              style={styles.chartTitleIcon}
            ></i>
            Estado de Revisión
          </h3>
          <button
            onClick={() => navigate("/revision-documentos")}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            style={{
              ...styles.headerButton,
              ...(isHovered && styles.headerButtonHover),
            }}
            title="Ir a revisión de documentos"
          >
            <i
              className="fa-solid fa-arrow-right"
              style={{
                ...styles.headerButtonIcon,
                ...(isHovered && styles.headerButtonIconHover),
              }}
            ></i>
          </button>
        </div>
      </div>
      <div
        style={{
          ...styles.chartBody,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: "40px 20px",
        }}
      >
        <div style={styles.progressContainer}>
          <div style={styles.progressBarContainer}>
            {reviewedPercentage > 0 && (
              <div
                style={{
                  ...styles.progressBarFilled,
                  width: `${reviewedPercentage}%`,
                }}
              />
            )}
            {pendingPercentage > 0 && (
              <div
                style={{
                  ...styles.progressBarEmpty,
                  width: `${pendingPercentage}%`,
                }}
              />
            )}
          </div>
        </div>

        <div style={styles.percentageText}>
          <div style={styles.percentageContainer}>
            <span style={styles.percentageNumber}>{reviewedPercentage}</span>
            <span style={styles.percentageSymbol}>%</span>
          </div>
          <div style={styles.percentageLabel}>Revisados</div>
        </div>
      </div>
    </div>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  chartCard: {
    background: "#fff",
    borderRadius: "12px",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    flex: 1,
    minHeight: 0,
    width: "100%",
  },
  chartHeader: {
    background: "linear-gradient(135deg, #f9fafb 0%, #f3f4f6 100%)",
    padding: "16px 20px",
    borderBottom: "1px solid #e5e7eb",
  },
  chartHeaderContent: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "8px",
    minHeight: "30px",
  },
  chartTitle: {
    margin: 0,
    fontSize: "16px",
    fontWeight: "600",
    color: "#2d3748",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    flex: 1,
  },
  chartTitleIcon: {
    fontSize: "20px",
    color: "#2563eb",
  },
  headerButton: {
    background: "transparent",
    border: "none",
    cursor: "pointer",
    padding: "4px 8px",
    borderRadius: "6px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 0.2s ease",
  },
  headerButtonHover: {
    background: "#e5e7eb",
  },
  headerButtonIcon: {
    fontSize: "14px",
    color: "#6b7280",
    transition: "all 0.2s ease",
  },
  headerButtonIconHover: {
    color: "#2563eb",
  },
  chartBody: {
    padding: "20px",
    display: "flex",
    flexDirection: "column",
  },
  progressContainer: {
    width: "100%",
    maxWidth: "600px",
    marginBottom: "2px",
  },
  progressBarContainer: {
    width: "100%",
    height: "60px",
    background: "#e5e7eb",
    borderRadius: "12px",
    overflow: "hidden",
    display: "flex",
    position: "relative",
    boxShadow: "inset 0 2px 4px rgba(0, 0, 0, 0.06)",
  },
  progressBarFilled: {
    height: "100%",
    background: "linear-gradient(90deg, #16a34a 0%, #14532d 100%)",
    transition: "width 0.5s ease",
  },
  progressBarEmpty: {
    height: "100%",
    background: "#f3f4f6",
    transition: "width 0.5s ease",
  },
  percentageText: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    marginTop: "24px",
  },
  percentageContainer: {
    display: "flex",
    alignItems: "baseline",
    justifyContent: "center",
    gap: "4px",
  },
  percentageNumber: {
    fontSize: "40px",
    fontWeight: "700",
    color: "#2d3748",
    lineHeight: 1,
  },
  percentageSymbol: {
    fontSize: "32px",
    fontWeight: "700",
    color: "#2d3748",
    lineHeight: 1,
  },
  percentageLabel: {
    fontSize: "24px",
    fontWeight: "600",
    color: "#6b7280",
    marginTop: "8px",
  },
};

export default EstadoRevisionDocumentos;
